module.exports = __webpack_public_path__ + "img/08_uk.19969291.svg";